import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  useConfigStore,
} from "../store/config";
import { getStgDomain } from "../common/runtimeConfig";

interface AfterHistoryChangeMessage {
  type: "afterHistoryChange";
  data: { pathname: string; moduleName?: string };
}
type PostMessage = AfterHistoryChangeMessage;

interface GlobalLanguageChangeMessage {
  type: "globalLanguageChange";
  data: "en" | "jp";
}
type ReceiveMessageEvent = {
  data: GlobalLanguageChangeMessage;
};

export const useUrfPostEvents = () => {
  const location = useLocation();
  const postMessage = (message: PostMessage) => {
    if (window.parent !== window) {
      window.parent.postMessage(
        message,
        `https://${getStgDomain()}`
      );
    }
  };

  useEffect(() => {
    postMessage({
      type: "afterHistoryChange",
      data: {
        pathname: location.pathname,
        moduleName: "",
        // moduleName: convertPathToModule(
        //   location.pathname?.split("/")?.filter((el) => el)?.[0]
        // ),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};

export const useUrfReceiveEvents = () => {
  const [updateLanguage] = useConfigStore((state) => [state.updateLanguage]);

  //Scenes：If the subapplication's route uses asynchronous loading and a request is made during loading.
  //Problem：Relying solely on the iframe's onLoad event may not ensure that the subapplication loads fully.
  //Solution: Put this hook in App.tsx
  const receiveMessage = (event: ReceiveMessageEvent) => {
    // need to use environment variables
    // if (event.origin !== "https://app.devsecops.freyafusion.com") return;
    switch (event.data?.type) {
      case "globalLanguageChange": {
        updateLanguage(event.data.data);
        break;
      }
      default:
        break;
    }
  };
  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage);
  }, []);
};
